import { useEffect } from 'react'
import { signIn, useSession } from 'next-auth/client'
import { useRouter } from 'next/router'
import Head from 'next/head'
import { GetServerSideProps } from 'next'
import queryString, { ParsedQuery } from 'query-string'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'

import SigninCover from '~/src/components/SigninCover'
import LoadingIndicator from '~/src/components/LoadingIndicator'
import ErrorBoundary from '~/src/components/ErrorBoundary'

export default function Signin(): JSX.Element {
  const [session, loading] = useSession()
  const router = useRouter()
  const { t } = useTranslation('signin')

  const handleClick = () => {
    signIn('email')
  }

  useEffect(() => {
    if (loading) {
      return
    }
    if (session) {
      const { asPath } = router
      const url = new URL(asPath, String(window.location))
      const parsed = queryString.parse(url.search) as ParsedQuery<string>

      router.push(String(parsed.from ?? '/'))
    }
  }, [session, loading, router])

  return (
    <ErrorBoundary>
      <LoadingIndicator open={loading || !!session} />
      <Head>
        <title>{t('pageTitle')}</title>
      </Head>
      <SigninCover onClick={handleClick} />
    </ErrorBoundary>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const i18n = await serverSideTranslations(context.locale ?? 'en', ['signin'])

  return { props: { ...i18n } }
}
